import { getRioClient } from '@chegg-me-components/utils';
/* istanbul ignore next */

var rioEndpoint = process.env.NODE_ENV === 'development' ? 'http://localhost:8042/' : 'https://analytics.test.cheggnet.com/rio-service-web/rest/rio-events/batch';
export var rioConfig = {
  property: 'me',
  endpoint: rioEndpoint,
  authState: 'logged_out',
  appId: 'signed-out-header',
  view: {
    property: 'chegg',
    experience: 'bundle',
    view_name: 'signed-out-header storybook'
  }
};
export var rioClient = getRioClient();